<section class="main">
    <div class="cover_bg"></div>
    <article class="profile_box">
        <div class="profile_box_block">
            <div class="container">
                <div class="profile_box_block__main">
                    <div class="profile_box_block__left">
                        <div class="card pro-card">
                            <div class="profile_img position-relative">
                                <div class="image">
                                    <img src="{{advisorProfile?.profilePic}}">
                                    <div class="onLine">&nbsp;</div>
                                </div>
                            </div>
                            <div class="profile_details">
                                <h4>{{advisorProfile?.astrologerName}}
                                    <div class="verify" *ngIf="advisorProfile?.isVerifiedByAp">
                                        <img src="/assets/icons/search-page/verify_img.svg" alt="" class="">
                                    </div>
                                </h4>
                                <p class="exprt">{{advisorProfile?.specializationArea}}</p>
                            </div>
                            <div class="review_box">
                                <div class="star_box d-flex text-center" *ngIf="advisorProfile">
                                    <ngx-stars [readonly]="true" [color]="'#ffa400'" [size]="1" [maxStars]="5"
                                        [initialStars]="advisorProfile?.averageRating"></ngx-stars>({{advisorProfile.averageRating}})
                                </div>

                                <div class="review d-flex align-items-center justify-content-center">
                                    <span class="d-block ratingCount">(4.0)</span>
                                    <div class="verticalDivider"></div>
                                    <span class="reviewCount">2 Reviews</span>
                                </div>
                            </div>
                            <div class="hrProfile"></div>
                            <div class="exp">
                                <p>Experience: <span>{{advisorProfile?.totalWorkExperience}}</span></p>
                            </div>
                        </div>
                        <div class="contactBtn">
                            <!-- <div class="btn_audio">
                                <a href="">
                                    <img src="/assets/icons/search-page/audio_img.svg" alt="">
                                    <button> Audio Call<span>₹16 per min</span></button>
                                </a>
                            </div> -->

                            <div class="btn_audio">

                                <!-- <div class="modalbtn" (click)="checkBalance(5)">
                                    <p>Modal Opening Button</p>
                                </div> -->

                                <button
                                    [ngClass]="advisorProfile?.chatService?.serviceStatus=='AVAILABLE'?'':'serviceUnavailable'"
                                    (click)="advisorProfile?.callService?.serviceStatus=='AVAILABLE'?callNow(advisorProfile?.callService?.servicePrice):unavailabel()">
                                    <img
                                        [src]="advisorProfile?.callService?.serviceStatus=='AVAILABLE'?'/assets/icons/search-page/audio_img.svg':'/assets/icons/search-page/audio_img.svg'" />
                                    <label>Audio
                                        Call<span>{{gS.currencySign}}{{advisorProfile?.callService?.servicePrice}}/min</span></label>
                                </button>
                            </div>

                            <div class="btn_chat">
                                
                                <!-- <div class="modalbtn" (click)="checkBalance(5)">
                                    <p>Modal Opening Button</p>
                                </div> -->

                                <!-- <button
                                    [ngClass]="advisorProfile?.chatService?.serviceStatus=='AVAILABLE'?'':'serviceUnavailable'"
                                    (click)="advisorProfile?.chatService?.serviceStatus=='AVAILABLE'?chatNow(advisorProfile?.chatService?.servicePrice):unavailabel()">
                                    <img
                                        [src]="advisorProfile?.chatService?.serviceStatus=='AVAILABLE'?'/assets/images/advisor_profile/chat_new.svg':'/assets/icons/search-page/chat_blue_img.svg'" />
                                    <label>Chat<span>{{gS.currencySign}}{{advisorProfile?.chatService?.servicePrice}}/min</span></label>
                                </button> -->
                            </div>

                            <!-- <div class="btn_video">
                                <a href="">
                                    <img src="/assets/icons/search-page/video_img.svg" alt="">
                                    <button> Video Call<span>₹16 per min</span></button>
                                </a>
                            </div> -->



                        </div>
                    </div>
                    <div class="profile_box_block__right">
                        <div class="exp_box">
                            <div class="workExperience_card">
                                <h3>Expertise</h3>
                                <div class="workExp">
                                    <span class="badge">{{advisorProfile?.specializationArea}}</span>
                                </div>
                            </div>
                            <div class="skills_card">
                                <h3>Skills</h3>
                                <div class="skill_bg">
                                    <span class="skills"
                                        *ngFor="let item of advisorProfile?.expertiseArea.split(',');let i =index;">{{i>0?'
                                        ':''}} {{item}}
                                    </span>
                                </div>
                            </div>

                        </div>

                        <div class="certiDiv">
                            <h3>Certified from</h3>
                            <div class="certIWorkExp">
                                <span class="badge">Indian Bar Association</span>
                                <span class="badge">Institute of Chartered Accountants of India</span>
                            </div>
                        </div>

                        <div class="aboutInfo">
                            <h3>About</h3>

                            <div class="content">

                                <div [ngClass]="{'show-less': showShortDesciption}">
                                    <p>{{advisorProfile?.aboutMe}}</p>
                                </div>
                                <button type="button" class="less_btn">
                                    <span (click)="alterDescriptionText()">{{ showShortDesciption ? 'Read More+':
                                        'Read less' }}</span>
                                </button>
                            </div>
                        </div>

                        <div class="ratingDiv" *ngIf="advisorProfile.customerFeedback">
                            <h3>Rating and Reviews</h3>
                            <div class="reviewTxt" *ngFor="let item of advisorProfile.customerFeedback">
                                <div class="image">
                                    <img
                                        src="https://s3.us-east-1.amazonaws.com/tal3nt/9dbeda8b-5479-4142-99ea-7e6d8c3def5e.jpg">
                                </div>

                                <div class="about">
                                    <div class="user_deatil">
                                        <div class="name">
                                            <p>{{item?.customerName.substr(0,8)+".."}}</p>

                                            <div class="star_rating">
                                                <ngx-stars [readonly]="true" [color]="'#ffa400'" [size]="1"
                                                    [maxStars]="5"
                                                    [initialStars]="advisorProfile?.averageRating"></ngx-stars>({{advisorProfile.averageRating}})
                                            </div>
                                        </div>

                                        <div class="date">
                                            <p> <span class="date">{{item |date:'MMM d, Y'}}</span></p>
                                        </div>
                                    </div>

                                    <div class="text">
                                        <p>{{item?.customerReview}}
                                            <a class="read_more" href="">Read More.</a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </article>





</section>


<!-- Low Balance Modal -->
<div class="modal-backdrop" *ngIf="showLowBalanceModal">
    <div class="modal-content">
        <h3>Low Balance</h3>
        <p>Dear User, you need a minimum balance of {{gS.currencySign}} {{minBalance}} to {{serviceName}} with
            {{advisorName}}.</p>
        <button (click)="goToWallet()" class="recharebtn">Recharge Wallet</button>
        <button (click)="closeModal()" class="closebtn">X</button>

    </div>
</div>

<app-call-form *ngIf="opencCallForm" (close)="this.closePopup($event)"
    (success)="this.successCall($event)"></app-call-form>
<app-home-lawyer-section [data]="urldata" [heading]="headingAstro"></app-home-lawyer-section>